import CashTamerHttpClient from './CashTamerHttpClient';
import CashTamerApiBase from './CashTamerApiBase';
import ContactSupportRequestModel from '@/models/contact/ContactSupportRequestModel';

export default class ContactApi extends CashTamerApiBase {
    public async contactSupportAsync(request: ContactSupportRequestModel): Promise<void> {

        try {
            const httpClient = new CashTamerHttpClient();

            await httpClient.postAsync('contact/support', request);
        }
        catch ( err ) {
            return this.handleApiError(err);
        }
    }
}
